import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateCoupon extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Coupon/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

// GET؛ با متد get صدا زده می‌شود
class GetAllCoupons extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Coupon/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

// بدنه‌ی درخواست: DeleteCouponDto { id }
class DeleteACoupon extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Coupon/Delete");
  }
  setCouponId(couponId) {
    this.data = { id: Number(couponId) };
  }
}

class EditACoupon extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Coupon/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

// GET؛ سفارش‌هایی که با این کوپن ثبت شده‌اند
class GetCouponOrders extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Coupon/GetOrdersByCouponId");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  CreateCoupon,
  GetAllCoupons,
  DeleteACoupon,
  EditACoupon,
  GetCouponOrders,
};
